@if (errorFeedback$ | async; as errorFeedback) {
  <dcr-dialog
    [open]="isOpen$ | async"
    [attr.headline]="errorFeedback.title"
    [attr.icon]="errorFeedback.icon"
    [attr.type]="errorFeedback.type"
    [attr.confirm-label]="errorFeedback.confirmLabel"
    [attr.cancel-label]="errorFeedback.cancelLabel"
    (confirm)="onFeedbackDialogConfirm(errorFeedback)"
    (cancel)="onFeedbackDialogCancel(errorFeedback)"
    (closed)="closedDialog()"
  >
    <div class="[ stack stack-space-xs ][ body-small ][ on-surface-variant ][ text-center ]">
      <div [innerHTML]="errorFeedback.message"></div>

      <div class="[ flex items-center gap-2xs justify-center ][ weight-bold ]">
        Blijft dit probleem zich voordoen?

        <dcr-inline-button
          [label]="'Contacteer ' + errorFeedback.supportLabel"
          [href]="'mailto:' + errorFeedback.supportMailAddress"
          leading-icon="shared:mail"
        ></dcr-inline-button>
      </div>
    </div>
  </dcr-dialog>
}
